<template>
  <section>
    <div v-if="loading">

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center">
        <h2 class="intro-y text-lg font-medium mr-auto mt-8">
            Cortes <app-title-custom></app-title-custom>
        </h2>
      </div>
      <div class="intro-y flex flex-col-reverse mt-2 sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon v-bind:name="'search'" v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"></app-icon>
            <input type="text" class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por codigo" v-model="filter.slug">
        </div>
        <div class="intro-y mt-2 mb-4 flex flex-col-reverse sm:flex-row items-center">
          <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
          <div class="w-full sm:w-auto flex">
              <!-- <button @click="openCreateModal()">Crear corter</button> -->
              <router-link to="/admin/emails" class="button text-white bg-theme-1 shadow-md mr-2">Regresar</router-link>
          </div>
        </div>
        </div>
      <!-- END: Filter -->

      <div class="intro-y chat grid grid-cols-12 gap-5 mt-5">
        <!-- BEGIN: Chat Side Menu -->
        <div class="col-span-12 lg:col-span-4 xxl:col-span-3">

            <div class="tab-content">
                <div class="tab-pane active" id="chats" role="tabpanel" aria-labelledby="chats-tab">
                    <div class="chat__chat-list overflow-y-auto scrollbar-hidden pr-1 pt-1">
                        <div class="intro-x cursor-pointer box relative flex items-center p-5" :class="{'mt-5': index != 0}"
                            v-for="(email, index) in filteredEmails" :key="email.slug" @click="checkElement(email.id)"
                            v-if="email.state_id == 4 || email.state_id == 6">
                            <div class="ml-2 overflow-hidden">
                                <div class="flex items-center">
                                  <div>
                                    <a href="javascript:;" class="font-medium">{{email.name}}</a>
                                    <div class="text-gray-600 text-xs whitespace-no-wrap">{{email.campaign.name}}</div>
                                  </div>
                                </div>
                                <div class="w-full truncate text-gray-600 mt-0.5">{{email.slug}}</div>
                                <div class="text-xs text-gray-500 ml-auto">{{email.date}}</div>
                            </div>
                            <div class="w-5 h-5 flex items-center justify-center absolute top-0 right-0 text-xs text-white rounded-full bg-theme-1 font-medium -mt-1 -mr-1">{{email.pendingCheck}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END: Chat Side Menu -->
        <div class="intro-y box col-span-12 lg:col-span-8 xxl:col-span-9" v-if="emailCheck.state_id == 4 || emailCheck.state_id == 6">
          <div class="flex items-center px-5 py-5 sm:py-0 border-b border-gray-200 dark:border-dark-5">
              <h2 class="font-medium text-base mr-auto">
                Lista de aprobación: {{ emailCheck.name }}
              </h2>
              <div class="nav nav-tabs ml-auto hidden sm:flex" role="tablist">
                <a data-toggle="tab" data-target="#latest-tasks-new" href="javascript:;" class="py-5 ml-6 active" id="latest-tasks-mobile-new-tab" role="tab" aria-selected="true">Actual</a>
              </div>
          </div>
          <div class="p-5">
              <div class="tab-content">
                  <div class="tab-pane active" id="latest-tasks-new" role="tabpanel" aria-labelledby="latest-tasks-new-tab">
                      <div class="flex items-center" :class="{'mt-5': index != 0}" v-for="(check, index) in filteredCheckList" :key="`${index}-checker`">
                          <div class="border-l-2 border-theme-1 pl-4">
                              <p class="font-medium">{{check.type.description}}</p>
                              <div class="text-gray-600">Equipo: {{check.type.teamName}}</div>
                          </div>
                          <div class="flex ml-auto" v-if="!check.user_id && check.type.team_id == user.team_id">
                            <button class="bg-green-600 button--sm button mb-2 mr-1" @click="changeCheckStatus(check, true)"><app-icon name="check" class="text-white"></app-icon></button>
                            <button class="bg-red-600 button--sm button mb-2 mr-1" @click="changeCheckStatus(check, false)"><app-icon name="cancel" class="text-white"></app-icon></button>
                          </div>
                          <div class="flex ml-auto" v-else>
                            <div v-if="check.user_id">
                              <button v-if="check.check" class="bg-green-900 button--sm button mb-2 mr-1" disabled><app-icon name="check" class="text-white"></app-icon></button>
                              <button v-else class="bg-red-900 button--sm button mb-2 mr-1" disabled><app-icon name="cancel" class="text-white"></app-icon></button>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import TitleCustom from '@/components/admin/partials/TitleCustom'

export default {
  name: 'AdminEmailCheck',
  data () {
    return {
      loading: false,
      boxedit: false,
      filter : {
        state: null,
        slug: ''
      },
      account_session: null,
      team_session: null,
      isUserEmployee: false,
      view: {
        entity: 'emailcheck',
        id: null
      },
      check_current: {
        entity: 'emailcheck',
        id: null
      }
    }
  },
  mounted () {
    this.account_session = localStorage.session_account;
    this.team_session = localStorage.session_team;
    this.isUserEmployee = (this.user.role != 4)
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      checks: 'getEmailChecks',
      emailCheck: 'getEmailCheck',
    }),
    filteredCheckList() {
      const emailChek = JSON.parse(JSON.stringify(this.emailCheck.email_check))

      return emailChek.sort((a, b) => ( a.type.team_id == this.user.team_id) ? -1 : 1 )
    },
    filteredEmails: function() {
      return this.checks.filter((item) => {
        if(item.campaign.project.account_id == this.account_session) {
          if(this.filter.slug != "")
          {
            return item.slug.match(this.filter.slug);
          }
          if(this.filter.slug == "")
          {
            return item;
          }
        }
      })
    },
  },
  async beforeMount () {
    if (this.$route.params.id) {
      this.checkElement(this.$route.params.id)
    }

    try {
      await this.getList('emailcheck')

      this.loading = true
    } catch (error) {}
  },
  methods: {
    async checkElement(value) {
      this.view.id = value
      await this.show(this.view)
    },
    changeCheckStatus(check, validation) {
        var vm = this
        vm.check_current.id = check.id
        vm.check_current.validation = validation
        vm.store(vm.check_current)
        .finally(element => {
          vm.checkElement(check.email_id)
        })
    },
    viewAccounts (val) {
      if(val == 'all') {
        this.account_session = null
      } else {
        this.account_session = localStorage.session_account;
      }
    },
    ...mapActions([
      'show',
      'getList',
      'store',
      'update'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    appTitleCustom: TitleCustom
  }
}
</script>



// WEBPACK FOOTER //
// EmailCheck.vue?51f014a4